<style lang="scss">
.community-modal {
    input {
        min-height: 64px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.15s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
}
</style>

<template>
    <div class="community-modal px-24">
        <div class="modal-inner py-32 px-24 py-md-48 px-md-40 text-center">
            <transition name="fade" tag="div" mode="out-in">
                <div v-if="step == 0" :key="0">
                    <span class="h5 d-block mb-32">{{ translations.title || 'Dit artikel is uitsluitend voor leden van de CTP Community.' }}</span>
                    <p class="mb-40 font-weight-light" v-html="translations.subtitle"></p>
                    <div class="d-md-flex justify-content-center mb-40">
                        <a @click="step = 1" class="btn btn-secondary-opaque mb-16 mb-md-0">{{ translations.login }}</a>
                    </div>
                    <div class="text-center">
                        <a class="back" :href="backLink">{{ translations.back }}</a>
                    </div>
                </div>

                <div v-if="step == 1" :key="1" class="form" :class="{'processing': processing}">
                    <span class="h2 d-block mb-40">{{ translations.login2 }}</span>
                    <ValidationObserver ref="observer" tag="form" @submit.prevent="submit()">
                        <ValidationProvider ref="email" vid="email" rules="required|email" v-slot="props" :name="formTranslations.email" :slim="true">
                            <div class="form-group position-relative d-flex flex-column flex-md-row mb-0" :class="props.classes">
                                <input type="email" id="email" class="form-control mr-16 mb-8 mb-md-0" :placeholder="formTranslations.email" v-model="formData.email" />
                                <button @click.stop="submit('/api/visitors')" class="btn btn-lg btn-secondary btn-special"><span>{{ formTranslations.login }}</span></button>
                            </div>
                            <div class="text-left mt-8"><span class="error">{{ props.errors[0] || compiledErrors[0] }}</span></div>
                        </ValidationProvider>
                    </ValidationObserver>

                    <div class="spinner-background">
                        <div class="spinner">

                        </div>
                    </div>

                    <p class="font-weight-light mt-32 mb-0">{{ translations.not_yet_member }} <a :href="portalLink">{{ translations.customer_portal }}</a>.</p>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import hasErrors from '@mixins/hasErrors'
import disableHtmlScroll from '@mixins/disableHtmlScroll'
import formBase from '@mixins/formBase'

export default {
    mixins: [hasErrors, formBase, disableHtmlScroll],

    props: {
        portalLink: {
            type: String,
            required: true
        },

        backLink: {
            type: String,
            required: true
        },

        translations: {
            type: Object,
            required: true
        },

        formTranslations: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            step: 0,

            formData: {
                email: ""
            }
        }
    },

    methods: {
        async submit(path) {
            const isValid = await this.$refs.observer.validate();
            if (isValid && path != null && path != '') {
                this.processing = true;
                axios
                    .post(path, this.formData)
                    .then((response) => {
                        if (response.data.hasOwnProperty('success')) {
                            this.errors = [];
                            window.location.reload(false);
                        };
                    })
                    .catch((error) => {
                        this.processing = false;
                        this.errors = error.response.data.errors
                    })
            }
        },
    },

    computed: {
        currentStep() {
            return this.step;
        },
    }
}
</script>
